<div class="input-group">
  <app-material-date-range
    class="me-2"
    id="selectedDateRangeGregorian"
    [(dateRange)]="dateRange"
    (dateRangeChange)="selectDateRange($event)"
  >
  </app-material-date-range>
  <div>
    <button 
      mat-stroked-button 
      class="dropdown-toggle ms-1"
      type="button" 
      id="downloadButtonGroup"
      data-bs-toggle="dropdown" 
      aria-expanded="false">
      Download
    </button>

    <ul class="dropdown-menu" aria-labelledby="downloadButtonGroup">
      <li>
        <a class="dropdown-item" (click)="downloadReports()">Export to Excel</a>
      </li>
    </ul>
  </div>
</div>
